export const medicineOptions = [
  { label: "Paracetamol", value: "paracetamol" },
  { label: "Amoxicillin", value: "amoxicillin" },
  { label: "Ibuprofen", value: "ibuprofen" },
  { label: "Omeprazole", value: "omeprazole" },
  { label: "Metformin", value: "metformin" },
  { label: "Aspirin", value: "aspirin" },
  { label: "Lisinopril", value: "lisinopril" },
  { label: "Atorvastatin", value: "atorvastatin" },
];


